import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getTriggersReport: analyticsTypes.GetTriggersReport = (params) => {
  return axios.post(`/analytics/triggers`, params);
};

type QueryFnType = typeof getTriggersReport;

type UseGetTriggersReport = {
  dateFrom: number;
  dateTo: number;
  expertIds: string[];
  config?: QueryConfig<QueryFnType>;
};

export const useGetTriggersReport = ({
  config = {},
  dateFrom,
  dateTo,
  expertIds,
}: UseGetTriggersReport) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analytics-triggers', dateFrom, dateTo, expertIds],
    queryFn: async () => await getTriggersReport({ dateFrom, dateTo, expertIds }),
    enabled: !!expertIds.length && !!dateFrom && !!dateTo,
    cacheTime: 0,
  });
};
